export const AVATAR_LOCALE_ZHCHT = {
    imgtitle: 'é»æä¿®æ¹',
    typeError: 'ä¸å³åçé¡åä¸æ­£ç¢º',
    sizeError: 'ä¸å³åçä¸è½å¤§æ¼',
    uploadError: 'åçä¸å³å¤±æï¼è«éè©¦!',
    loadError: 'å è¼é¯èª¤'
};
